<div  class="program" *ngIf="program">
    <div class="program-overlay" (click)="close.emit()"></div>
    <div class="program-panel horizontal-focusable-container" data-blocked>
        <div class="image">
            <div class="image-gradient"></div>
                <img [src]="program.image" [alt]="program.name"/>
        </div>
        <p class="subtitle">{{ program.startTimeEpoch | date : 'EEE, MMM dd | H:mm' }} - {{program.endTimeEpoch | date: 'H:mm'}}</p>
        <div class="title-container">
            <p class="title">{{program.name}}</p>
        </div>
        <div class="info" *ngIf="program">
            <span *ngIf="program.ratings && program.ratings.length > 0 " class="rating">{{ program.ratings[0].v }}</span>
            <p>
                {{ program.contentGenre | MetaListPipe : '•' }}
            </p>
        </div>
        <p [attr.aria-label]="program.description" class="description">{{program.description}}</p>
        <div class="actions">
            <button aria-live="polite" class="btn btn-cta focusable-element" tabindex="0" (click)="play.emit(program)">
                <app-icon name="play"></app-icon>
                {{'epg.playNow' | translate }}</button>
        </div>
    </div>
</div>